import React from 'react';
import { BookOpenIcon, CheckCircleIcon } from 'lucide-react';
export const CourseModules = () => {
  return <section className="mb-10" data-id="element-102">
      <h2 className="text-xl font-bold text-blue-800 mb-6 flex items-center" data-id="element-103">
        <BookOpenIcon className="w-6 h-6 mr-2 text-blue-600" data-id="element-104" />
        Met de cursus Liefdevol Communiceren ontdek je hoe je je hond écht kunt
        begrijpen, zodat jullie een ongekend sterke band van vertrouwen op
        kunnen bouwen
      </h2>

      <p className="mb-6 leading-relaxed" data-id="element-105">
        De cursus 'Liefdevol Communiceren' bestaat uit 6 modules die je stap
        voor stap meenemen in de hondentaal:
      </p>

      <div className="space-y-4 mb-8" data-id="element-106">
        <div className="border border-blue-200 rounded-lg overflow-hidden bg-white" data-id="element-107">
          <div className="bg-blue-50 p-4 flex items-start" data-id="element-108">
            <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3 flex-shrink-0" data-id="element-109">
              1
            </div>
            <div data-id="element-110">
              <h4 className="font-bold text-blue-800" data-id="element-111">
                Module 1: Tools voor het dagelijks leven
              </h4>
            </div>
          </div>
          <div className="p-4" data-id="element-112">
            <p className="text-sm text-gray-700" data-id="element-113">
              De basis van hondencommunicatie. Je leert de signalen herkennen
              die je hond elke dag gebruikt, en hoe je zelf deze signalen kunt
              inzetten.
            </p>
          </div>
        </div>

        <div className="border border-blue-200 rounded-lg overflow-hidden bg-white" data-id="element-114">
          <div className="bg-blue-50 p-4 flex items-start" data-id="element-115">
            <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3 flex-shrink-0" data-id="element-116">
              2
            </div>
            <div data-id="element-117">
              <h4 className="font-bold text-blue-800" data-id="element-118">
                Module 2: Sociale Vaardigheden — Omgangsregels
              </h4>
            </div>
          </div>
          <div className="p-4" data-id="element-119">
            <p className="text-sm text-gray-700" data-id="element-120">
              Hoe honden onderling omgaan en wat dit betekent voor jouw
              interactie met je hond. Leer de 'etiquette' van de hondenwereld.
            </p>
          </div>
        </div>

        <div className="border border-blue-200 rounded-lg overflow-hidden bg-white" data-id="element-121">
          <div className="bg-blue-50 p-4 flex items-start" data-id="element-122">
            <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3 flex-shrink-0" data-id="element-123">
              3
            </div>
            <div data-id="element-124">
              <h4 className="font-bold text-blue-800" data-id="element-125">
                Module 3: Sociale Vaardigheden — Tafelmanieren
              </h4>
            </div>
          </div>
          <div className="p-4" data-id="element-126">
            <p className="text-sm text-gray-700" data-id="element-127">
              Praktische communicatie rondom eten, rust en grenzen stellen.
              Zonder confrontatie, met respect.
            </p>
          </div>
        </div>

        <div className="border border-blue-200 rounded-lg overflow-hidden bg-white" data-id="element-128">
          <div className="bg-blue-50 p-4 flex items-start" data-id="element-129">
            <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3 flex-shrink-0" data-id="element-130">
              4
            </div>
            <div data-id="element-131">
              <h4 className="font-bold text-blue-800" data-id="element-132">
                Module 4: Sociale Vaardigheden — Jouw reactie
              </h4>
            </div>
          </div>
          <div className="p-4" data-id="element-133">
            <p className="text-sm text-gray-700" data-id="element-134">
              Hoe je reageert op ongewenst gedrag, op een manier die je hond
              begrijpt én respecteert.
            </p>
          </div>
        </div>

        <div className="border border-blue-200 rounded-lg overflow-hidden bg-white" data-id="element-135">
          <div className="bg-blue-50 p-4 flex items-start" data-id="element-136">
            <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3 flex-shrink-0" data-id="element-137">
              5
            </div>
            <div data-id="element-138">
              <h4 className="font-bold text-blue-800" data-id="element-139">
                Module 5: Het Attentie Signaal
              </h4>
            </div>
          </div>
          <div className="p-4" data-id="element-140">
            <p className="text-sm text-gray-700" data-id="element-141">
              Leer hoe je de aandacht van je hond krijgt zonder te roepen,
              commanderen of te corrigeren.
            </p>
          </div>
        </div>

        <div className="border border-blue-200 rounded-lg overflow-hidden bg-white" data-id="element-142">
          <div className="bg-blue-50 p-4 flex items-start" data-id="element-143">
            <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3 flex-shrink-0" data-id="element-144">
              6
            </div>
            <div data-id="element-145">
              <h4 className="font-bold text-blue-800" data-id="element-146">
                Module 6: Het Handgebaar
              </h4>
            </div>
          </div>
          <div className="p-4" data-id="element-147">
            <p className="text-sm text-gray-700" data-id="element-148">
              Communiceer met je hond zonder woorden. Een krachtige techniek
              voor rustige samenwerking.
            </p>
          </div>
        </div>
      </div>

      <p className="mb-6 leading-relaxed" data-id="element-149">
        Elke module bevat video's met uitleg, praktijkbeelden en voorbeelden
        zodat je precies ziet hoe het werkt. Plus printbare stappenplannen die
        je kunt gebruiken tijdens het oefenen.
      </p>

      <div className="bg-green-50 p-6 rounded-lg border border-green-200 mb-8" data-id="element-150">
        <h3 className="text-lg font-bold text-green-800 mb-4" data-id="element-151">
          Inclusief 3 bonussen:
        </h3>
        <ul className="space-y-3" data-id="element-152">
          <li className="flex items-start" data-id="element-153">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-154" />
            <span data-id="element-155">
              <strong data-id="element-156">Bonus Masterclass "Honden Geschiedenis"</strong> — Begrijp
              waar het gedrag van je hond vandaan komt en waarom communicatie zo
              essentieel is.
            </span>
          </li>
          <li className="flex items-start" data-id="element-157">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-158" />
            <span data-id="element-159">
              <strong data-id="element-160">8 printbare stappenplannen</strong> — Voor elke
              communicatievaardigheid een handig overzicht dat je kunt
              uitprinten.
            </span>
          </li>
          <li className="flex items-start" data-id="element-161">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-162" />
            <span data-id="element-163">
              <strong data-id="element-164">Levenslange toegang</strong> — Je kunt de cursus op je
              eigen tempo volgen en zo vaak terugkijken als je wilt.
            </span>
          </li>
        </ul>
      </div>

      <div className="w-full mb-6" data-id="element-165">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4q5cC71mhLz2oJ2dhhpDRD/Scherm_afbeelding_2025-08-15_om_15.46.41-min.png" alt="Vrouw wandelt ontspannen met haar hond op een bospad" className="w-full h-auto rounded-lg shadow-md" data-id="element-166" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-167">
          Een stressvrij leven voor je hond. En voor jou.
        </p>
      </div>
    </section>;
};